<template>
  <div class="!border border-gray-100 w-full !shadow rounded-md py-1 px-4">
    <div class="grid grid-cols-12">
      <div class="flex items-center col-span-2 gap-5">
        <button type="button" @click="togglePinNote()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 "
            :class="{
              'text-yellow-400 fill-yellow-400': noteData.pinned,
              'text-black fill-white hover:text-yellow-400 hover:fill-yellow-400 transition-colors duration-300': !noteData.pinned
            }"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
            />
          </svg>
        </button>
        <span
          class="rounded-md py-1 px-2 text-sm bg-gradient-to-tr from-gray-400 to-gray-500 text-white font-medium"
        >
          {{ noteData.created_at }}
          {{ noteData.notetaker }} 
        </span>
      </div>
      <div class="flex items-center col-span-8 px-2">
        <div
          class="w-full"
          @dblclick="
            () => {
              if (!editing) {
                editing = true
              }
            }
          "
        >
          <textarea
            ref="note"
            class="w-full focus:outline-none resize-none rounded-md p-2 select-none"
            :class="{
              'cursor-pointer bg-gray-100 select-none': !editing,
              'bg-gray-200': editing
            }"
            :readonly="!editing"
            v-model="text"
            :disabled="!editing"
          ></textarea>
        </div>
      </div>
      <div class="flex items-center col-span-2 justify-end gap-4">
        <Button
          v-if="!editing"
          type="button"
          class="rounded-md text-sm uppercase h-8"
          color="gray"
          size="sm"
          @click="onEdit()"
          >Edit</Button
        >
        <!-- :onClick="() => {editing = true}" -->
        <!-- :onClick="debugging()" -->
        <Button
          v-if="editing"
          type="button"
          class="rounded-md text-sm uppercase h-8"
          color="gray"
          size="sm"
          :disabled="saving"
          @click="saveNote()"
          >Save</Button
        >
        <button
          v-if="deleteReady == false"
          type="button"
          @click="initiateDeleteNote()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            />
          </svg>
        </button>
        <div class="grid grid-rows-2 place-items-center"
          v-else>
          <span>Are You Sure?</span>
          <div class="grid grid-cols-2 gap-2 place-items-center">
            <button class="rounded-md bg-gray-200 p-1"
              @click="deleteNote()">
              Yes
            </button>
            <button class="rounded-md bg-gray-200 p-1"
              @click="cancelDeleteReady()">
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { putStudentNotes } from '../../services/api.js'
import Button from '../Button.vue'

export default {
  props: {
    noteData: Object,
    studentId: Number
  },
  components: {
    Button
  },
  data() {
    return {
      text: this.noteData.note,
      editing: false,
      saving: false,
      deleteReady: false,
    }
  },
  mounted() {
    this.resizeNote()
  },
  methods: {
    onEdit(){
      this.editing = true
    },
    async saveNote() {
      this.saving = true
      await putStudentNotes(
        {
          ...this.noteData,
          note: this.text
        },
        this.studentId
      )
      this.editing = false
      this.saving = false
      this.$emit('reloadNotes')
    },
    async togglePinNote() {
      await putStudentNotes(
        {
          ...this.noteData,
          pinned: !this.noteData.pinned
        },
        this.studentId
      )
      this.$emit('reloadNotes')
    },
    initiateDeleteNote() {
      this.deleteReady = true
    },
    cancelDeleteReady() {
      this.deleteReady = false
    },
    async deleteNote() {
      await putStudentNotes(
        {
          ...this.noteData,
          deleted: true
        },
        this.studentId
      )
      this.$emit('reloadNotes')
    },
    resizeNote() {
      this.$refs.note.style.height = 'auto'
      this.$refs.note.style.height = this.$refs.note.scrollHeight + 'px'
    }
  },
  watch: {
    text: function() {
      this.$nextTick(() => this.resizeNote())
    },
    editing: function() {
      if (this.editing) {
        this.$nextTick(() => {
          this.$refs.note.focus()
          const selectionEnd = this.$refs.note.selectionEnd
          this.$refs.note.setSelectionRange(selectionEnd, selectionEnd)
        })
      }
    }
  }
}
</script>

<style></style>
